import { useEffect, useState } from 'react'

export const useIsMounted = (options?: {
  onMount?: () => void
  onUnmount?: () => void
}) => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
    options?.onMount?.()

    return () => {
      setIsMounted(false)
      options?.onUnmount?.()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return isMounted
}
